import {
  LinearProgress,
  Typography,
  useMediaQuery,
  SxProps,
  Box,
} from '@mui/material';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { theme } from '../../../../src/theme/themeProvider';

interface IProps {
  score: number;
  variant: 'small' | 'md' | 'lg';
  linearProgressStyles?: SxProps;
}

export const ScoreProgressBar = (props: IProps) => {
  const { score, variant, linearProgressStyles } = props;

  const formattedScore = Number(score.toFixed(2));
  const isNegative = formattedScore < 0;
  const clampedValue = Math.max(0, formattedScore);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isIpad = useMediaQuery(theme.breakpoints.down('lg'));
  const isIpadOnly = !isMobile && isIpad;
  return (
    <Box sx={{ position: 'relative', width: '100%', boxSizing: 'border-box' }}>
      <LinearProgress
        variant="determinate"
        sx={{
          // minWidth: { xs: pxToRem(109), md: pxTovW(79.93) },
          height:
            variant === 'small'
              ? { xs: pxToRem(14), lg: pxTovW(16) }
              : variant === 'md'
              ? { xs: pxToRem(16), md: pxTovW(24) }
              : { xs: pxToRem(18), md: pxToRem(15), lg: pxTovW(27) },
          borderRadius: { xs: pxToRem(4), md: pxTovW(4) },
          // backgroundColor: '#B3B3B3'
          backgroundColor: isNegative ? '#FFF0F0' : '#B3B3B3',
          border: isNegative ? '1.5px solid #FF3A3A' : 'none',
          width: '100%',
          // flexGrow: 1,
          ...linearProgressStyles,
        }}
        // color={
        //   formattedScore < 30
        //     ? 'error'
        //     : formattedScore < 70 // no change is  required here as === 30  and === 70 are already handled in the above condition
        //     ? 'warning'
        //     : 'success'
        // }
        color={
          isNegative
            ? 'error'
            : formattedScore < 30
            ? 'error'
            : formattedScore < 70
            ? 'warning'
            : 'success'
        }
        value={clampedValue}
      />
      <Typography
        variant="smallText"
        sx={{
          position: 'absolute',
          // color: 'white',
          color: isNegative ? '#FF3A3A' : 'white',
          top:
            variant === 'small'
              ? '1%'
              : variant === 'md' && isIpadOnly
              ? pxToRem(-2)
              : '10%',
          left: { xs: pxToRem(30), md: pxTovW(30) },
          transform: 'translateX(-50%)',
        }}
      >
        {formattedScore}%
      </Typography>
    </Box>
  );
};
